import { clearRedeemClientCache } from './redeem-queue'

export type AppVersionInfo = {
  tag: string
  label: string
}

export function parseVersionPayload(data: unknown): AppVersionInfo | null {
  if (!data || typeof data !== 'object') return null
  const rec = data as Record<string, unknown>
  const version = String(rec.version || '').trim()
  const buildTime = String(rec.buildTime || '').trim()
  const label = version || buildTime
  if (!label) return null
  return {
    tag: version ? `ver:${version}` : `time:${buildTime}`,
    label,
  }
}

export function shouldPromptVersionUpdate(seenTag: string, next: AppVersionInfo | null) {
  if (!next) return { seen: seenTag, prompt: false }
  if (!seenTag) return { seen: next.tag, prompt: false }
  return { seen: seenTag, prompt: seenTag !== next.tag }
}

export async function fetchAppVersion(url = '/version.json'): Promise<AppVersionInfo | null> {
  const r = await fetch(`${url}?t=${Date.now()}`, { cache: 'no-store' })
  if (!r.ok) return null
  return parseVersionPayload(await r.json().catch(() => null))
}

export async function refreshPageAndClearCache() {
  clearRedeemClientCache()
  if (typeof caches !== 'undefined') {
    try {
      const keys = await caches.keys()
      await Promise.all(keys.map((key) => caches.delete(key)))
    } catch {
      /* ignore */
    }
  }
  window.location.reload()
}
